<template>
  <div style="height: 300px" class="overflow-auto">
    <div class="p-4">
      <div class="mb-4">
        <TextField
          :inputId="'checklistItemInput'"
          :textMaxlength="100"
          :showcharLimit="true"
          :inputext="checklistTitle"
          :placholderText="`Checklist Title`"
          :lableText="'Checklist Title'"
          :autoFocus="true"
          @inputChangeAction="(data) => (checklistTitle = data)"
        />
      </div>
    </div>
    <div
      class="absolute -bottom-1 bg-white w-full flex justify-end pr-3 pt-3"
    >
      <div class="text-rigth flex gap-2 mb-3">
        <Button
          :btnSize="'medium'"
          :textColor="'text1'"
          :btnColor="'gray1'"
          :btnText="'Cancel'"
          @buttonAction="cancelAddChecklist"
        />
        <Button
          :disabled="checklistTitle === ''"
          :btnSize="'medium'"
          :textColor="'white'"
          :btnColor="'success'"
          :btnText="'Add'"
          @buttonAction="AddNewChecklist()"
        />
      </div>
    </div>
  </div>
</template>

<script>
import Button from "@/View/components/globalButton.vue";
import TextField from "@/View/components/textfield.vue";

export default {
  components: {
    Button,
    TextField,
  },
  data() {
    return {
      checklistTitle: "",
    };
  },
  methods: {
    cancelAddChecklist() {
      this.$emit("handelAddNewChecklist", null);
    },
    AddNewChecklist() {
      if (this.checklistTitle !== "") {
        let data = {
          checkListItemMasterId: 0,
          checkListTitle: this.checklistTitle,
          checkLiTitle: this.checklistTitle,
          categoryName: '',
          isActive: true,
          selected: true,
        };

        this.$emit("handelAddNewChecklist", data);
      }
    },
  },
};
</script>

<style scoped>
</style>
